import { Container, IDestroyOptions, Rectangle, Sprite } from "pixi.js";
import { GiftResourcePackage } from "../resources/GiftResourcePackage";
import { gsap, Quad } from "gsap";
type Timeline = gsap.core.Timeline;

export class GiftBox extends Container {
    private static readonly GIFT_BOX_SHOW_ANIMATION_TIME = 1.5;

    private readonly giftResources: GiftResourcePackage;
    private box: Container;
    private boxCover: Sprite;
    private boxBase: Sprite;
    private boxGlow: Sprite;

    public constructor(giftResources: GiftResourcePackage) {
        super();
        this.giftResources = giftResources;
        this.build();
    }

    private build(): void {
        this.box = new Container();
        this.addChild(this.box);
        this.boxGlow = new Sprite(this.giftResources.assets_views_gift_ui_gift_box_glow_png);
        this.boxGlow.anchor.set(0.5, 0.5);
        this.boxGlow.angle = 8;
        this.boxGlow.scale.set(1.75, 1.75);
        this.box.addChild(this.boxGlow);
        this.boxBase = new Sprite(this.giftResources.assets_views_gift_ui_gift_box_base_png);
        this.boxBase.anchor.set(0.5, 0.5);
        this.boxGlow.position.set(0, -this.boxBase.height * 0.15);
        this.box.addChild(this.boxBase);
        this.boxCover = new Sprite(this.giftResources.assets_views_gift_ui_gift_box_cover_png);
        this.boxCover.position.set(-8, -this.boxBase.height * 0.4);
        this.boxCover.anchor.set(0.5, 0.5);
        this.box.addChild(this.boxCover);
        this.box.hitArea = new Rectangle(-this.box.width * 0.28, -this.box.height * 0.35, this.box.width * 0.6, this.box.height * 0.6);
    }

    public openBoxAnimation(): gsap.core.Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.to(this.box.scale, { x: 1.1, y: 0.85, duration: GiftBox.GIFT_BOX_SHOW_ANIMATION_TIME / 8, yoyo: true, repeat: 1, ease: Quad.easeInOut });
        animationTimeLine.to(this.box, { y: this.box.y + 100, duration: GiftBox.GIFT_BOX_SHOW_ANIMATION_TIME / 8, yoyo: true, repeat: 1, ease: Quad.easeInOut }, "<");
        animationTimeLine.to(this.box.scale, { x: 1, y: 1, duration: GiftBox.GIFT_BOX_SHOW_ANIMATION_TIME / 9, ease: Quad.easeInOut }, "<90%");
        animationTimeLine.to(this.box, { y: this.box.y, duration: GiftBox.GIFT_BOX_SHOW_ANIMATION_TIME / 9, ease: Quad.easeInOut }, "<");
        animationTimeLine.to(this.boxCover, { angle: -25, x: -100, y: -220, duration: GiftBox.GIFT_BOX_SHOW_ANIMATION_TIME / 8, ease: "power2.in" }, "<");
        animationTimeLine.then(() => animationTimeLine?.kill());
        return animationTimeLine;
    }

    public hideBoxGlowTween(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.to(this.boxGlow.scale, { x: 0, y: 0, duration: 0.4 });
        animationTimeLine.then(() => {
            animationTimeLine.kill();
        });
        return animationTimeLine;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}
